module.exports = __webpack_public_path__ + "img/s5.e62f2ec4.png";